import styled from "styled-components";
import { Button, Paper, TextField } from "@material-ui/core";

export const Container = styled(Paper)`
  max-width: 700px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  padding: 28px;

  fieldset {
    padding-top: 28px;
  }

  .MuiFormHelperText-root {
    color: red;
  }

  .customer-already-exists {
    color: #fff;

    margin: 10px;

    :hover {
      cursor: pointer;
    }

    a {
      color: #fff;
      padding-left: 10px;
    }
  }

  .react-tel-input {
    margin-bottom: 20px;
  }

  .react-tel-input .form-control {
    width: 100%;
  }

  .react-tel-input + .Mui-error {
    margin-top: -17px;
    margin-bottom: 20px;
  }

  fieldset + fieldset {
    margin-top: 20px;
  }
`;

export const Field = styled(TextField)`
  margin-bottom: 20px;
`;

export const AlertContainer = styled.div`
  padding: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const ButtonAlert = styled(Button)`
  font-weight: bold;
  font-size: 16px;

  margin-bottom: 10px;
  margin-top: 20px;
`;
